import { useAsyncCall } from "hooks";

import {
  useAssignNextWorkflowToConditionsGroupAction,
  useBulkUpdateNextWorkflowSortOrder,
  useRemoveNextWorkflowFromConditionsGroupAction,
  useUpdateNextWorkflowSortOrder,
} from ".";

export function useNextWorkflowOrderAction() {
  const [call, running] = useAsyncCall();

  const assignToConditionsGroup =
    useAssignNextWorkflowToConditionsGroupAction();
  const removeFromConditionsGroup =
    useRemoveNextWorkflowFromConditionsGroupAction();
  const updateSortOrder = useUpdateNextWorkflowSortOrder();
  const bulkUpdateSortOrder = useBulkUpdateNextWorkflowSortOrder();

  return {
    running: running,
    reOrderNextWorkflow: ({ orderedItems, target }) => {
      return call(async () => {
        if (target?.id && !target?.conditions)
          await updateSortOrder(target.id, orderedItems);
        else {
          bulkUpdateSortOrder(orderedItems);
        }
      });
    },
    assignNextWorkflowToConditionsGroup: ({
      orderedItems,
      target,
      targetGroup,
    }) => {
      return call(async () => {
        if (!(await updateSortOrder(target?.id, orderedItems))) return;
        await assignToConditionsGroup(target.id, targetGroup.id);
      });
    },
    removeNextWorkflowFromConditionsGroup: ({ orderedItems, target }) => {
      return call(async () => {
        if (!(await removeFromConditionsGroup(target.id))) return;
        await updateSortOrder(target?.id, orderedItems);
      });
    },
  };
}

export default useNextWorkflowOrderAction;
